import { schemas } from "../generated/serverClient";
import { z } from "zod";

export const VehicleTypeEnum = schemas.VehicleDto.shape.type;
export type VehicleType = z.infer<typeof VehicleTypeEnum>;

export const OWN_MOTORCYCLE_PSEUDO_ID = "__own_motorcycle__";
